const events = [
    {
        selector: '[data-event]',
        path: { filename: 'eventCard' },
    },
];

export { events };
